import { useMutation, useQuery } from "@apollo/client"
import { BuilderComponent } from "@builder.io/react"
import { Formik } from "formik"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { GET_ACTIVE_ORDER } from "../../components/ShoppingCart/ShoppingCart.vendure"
import {
  ADD_PAYMENT_TO_ORDER,
  TRANSITION_TO_ARRANGING_PAYMENT,
} from "../../pages/checkout.vendure"

export function ConfirmationStage({ nextStage, prevStage }) {
  const staticData = useStaticQuery(graphql`
    query WishlistQuery {
      allBuilderModels {
        wishlist(limit: 1, options: { cachebust: true }) {
          content
        }
      }
    }
  `)

  const wishlistContent = staticData?.allBuilderModels?.wishlist?.[0]?.content

  const { data, error, loading } = useQuery(GET_ACTIVE_ORDER)

  const [transitionToArrangingPayment] = useMutation(
    TRANSITION_TO_ARRANGING_PAYMENT
  )

  const [addPaymentToOrder] = useMutation(ADD_PAYMENT_TO_ORDER)

  const [inputs, setInputs] = React.useState({ confirmationMessage: "", orderCode: "" })

  // Handle loading state
  if (loading) {
    return <div className="text-center py-4">Chargement...</div>
  }

  // Handle error or completed order (no active order)
  if (error) {
    return <div className="alert alert-danger">Erreur: {error.message}</div>
  }

  // If order was completed and we have a confirmation message, show success
  if (!data?.activeOrder && inputs.confirmationMessage) {
    return (
      <div>
        {wishlistContent && <BuilderComponent name="wishlist" content={wishlistContent} />}

        {inputs.orderCode && (
          <p>
            <span className="text-muted">Référence: </span> {inputs.orderCode}
          </p>
        )}

        <div className="alert alert-success d-flex align-items-center" role="alert">
          <i className="ci-check-circle me-2 fs-4"></i>
          <div>
            <h4 className="alert-heading mb-1">Demande envoyée !</h4>
            <p className="mb-0">{inputs.confirmationMessage}</p>
          </div>
        </div>
      </div>
    )
  }

  // If no active order and no confirmation, redirect back
  if (!data?.activeOrder) {
    return (
      <div className="alert alert-warning">
        Aucune commande active. <a href="/products">Retourner à la boutique</a>
      </div>
    )
  }

  return (
    <div>
      {wishlistContent && <BuilderComponent name="wishlist" content={wishlistContent} />}

      <p>
        <span className="text-muted">Référence: </span> {data.activeOrder.code}
      </p>

      {inputs.confirmationMessage && (
        <div className="alert alert-success d-flex align-items-center" role="alert">
          <i className="ci-check-circle me-2 fs-4"></i>
          <div>
            <h4 className="alert-heading mb-1">Demande envoyée !</h4>
            <p className="mb-0">{inputs.confirmationMessage}</p>
          </div>
        </div>
      )}

      {inputs.confirmationMessage.length === 0 && (
        <Formik
          onSubmit={({ __typename, id, ...formData }) => {
            // Save order code before completing
            const orderCode = data.activeOrder?.code || ""
            transitionToArrangingPayment().then(() =>
              addPaymentToOrder({
                variables: {
                  input: {
                    method: "example-payment-provider",
                    metadata: {
                      message: "Pas de paiement car liste de souhaits",
                    },
                  },
                },
              }).then(() => {
                setInputs({
                  orderCode: orderCode,
                  confirmationMessage:
                    "Votre demande est enregistrée, nous allons vous contacter prochainement.",
                })
              })
            )
          }}
          initialValues={{}}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <button
                      className="btn btn-secondary d-block w-100"
                      onClick={prevStage}
                      type="button"
                    >
                      <i className="ci-arrow-left mt-sm-0 me-1"></i>
                      <span className="d-none d-sm-inline">
                        Modifier mes informations
                      </span>
                      <span className="d-inline d-sm-none">Retour</span>
                    </button>
                  </div>

                  <div className="col-sm-6">
                    <button
                      className="btn btn-primary d-block w-100"
                      type="submit"
                    >
                      <span className="d-none d-sm-inline">
                        Je comprends et je confirme ma liste
                      </span>
                      <span className="d-inline d-sm-none">Confirmer</span>
                      <i className="ci-arrow-right mt-sm-0 ms-1"></i>
                    </button>
                  </div>
                </div>
              </form>
            </>
          )}
        </Formik>
      )}
    </div>
  )
}
